<template minapp='mpx' xlang='wxml'>
  <es-picker 
  value="{{innerValue}}"
  columns="{{columns}}"
  showToolBar="{{showToolBar}}"
  bind:cancel="onCancel"
  bind:confirm="onConfirm"
  bind:input="onChange"
  />
</template>

<script>
import { createComponent } from '@didi/es-mpx-creator'
import PickerProps from './props'
import { getRangeYear, getRange, getDate, addZero, getFullDate, getMonthEndDay } from './date'

const current = new Date().getFullYear()
const defaultFormtter = (val, type) => val;

const getIndex = (arr, value) => arr.findIndex(item => parseInt(item, 10) == value)

createComponent({
  props: {
    ...PickerProps,
    value: {
      type: Number,
      optionalTypes: [String, Date],
    },
    type: {
      type: String,
      value: 'datetime', //  datetime| time | date | year-month
    },
    minDate: {
      type: Number,
      optionalTypes: [String, Date],
      value: new Date(current - 10, 0, 1).getTime()
    },
    maxDate:{
      type: Number,
      optionalTypes: [String, Date],
      value: new Date(current + 10, 11, 31).getTime()
    },
    minHour: {
      type: Number,
      value: 0
    },
    maxHour: {
      type: Number,
      value: 23
    },
    minMinute: {
      type: Number,
      value: 0
    },
    maxMinute: {
      type: Number,
      value: 59
    },

    formatter: null
  },

  data: {
    innerValue: [],
    columns: []
  },

  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.columns = this.getOriginColumns()
        this.$nextTick(() => {
          this.innerValue = this.getCurrentTime(value)
        })
      }
    }
  },

  methods: {
    onCancel() {
      this.$trigger('cancel')
    },

    onConfirm() {
      this.$trigger('confirm')
    },

    onChange(event) {
      const { value } = event.detail;
      if (this.type !== 'time' || this.type !== 'year-month') {
        // this.columns = this.getOriginColumns()
      } 

      this.$trigger('input', {
        value: this.transform(value)
      })
    },

    getValue(index, column) {
      return this.columns[index][column]
    },

    getEndDate(date) {
      date = new Date(date)
      return getMonthEndDay(
        date.getFullYear(), 
        date.getMonth() + 1
      )
    },

    getCurrentTime(value) {
      const { type, columns, minDate, maxdate } = this;
      if (type === 'time') {
        const times = value.split(":")
        return times.map((item, index) => getIndex(columns[index],addZero(item)))
      } 

      let dateArr = getFullDate(value || minDate);

      if(type === 'date') dateArr = dateArr.slice(0, 3) 
      if(type === 'year-month') dateArr = dateArr.slice(0, 2)
      return dateArr.map((item, index) => getIndex(columns[index], item))
    },

    getBoundary(type, value) {
      const boundary = getDate(this[`${type}Date`])
      const year = boundary.getFullYear()
      let month = 1;
      let date = 1;
      let hour = this.minHour;
      let minute = this.minMinute; 

      if (type === 'max') {
        month = 12;
        date = this.getEndDate(value);
        hour = this.maxHour;
        minute = this.maxMinute;
      }

      if (value.getFullYear() === year) {
        month = boundary.getMonth() + 1;
        if (value.getMonth() + 1 === month) {
          date = boundary.getDate();
          if (value.getDate() === date) {
            hour = boundary.getHours();
            if (value.getHours() === hour) {
              minute = boundary.getMinutes();
            }
          }
        }
      }

      return {
        year,
        month,
        date,
        hour,
        minute,
      };
    },

    getDateTime() {
      const date = getDate(this.value)
      const min = this.getBoundary('min', date)
      const max = this.getBoundary('max', date)

      return [
        [min.year, max.year, 'year'],
        [min.month, max.month, 'month'],
        [min.date, max.date, 'day'],
        [min.hour, max.hour, 'hour'],
        [min.minute, max.minute, 'minute']
        // [minDate.getSeconds(), maxDate.getSeconds(), 'second']
      ]
    },

    transform(innerValue) {
      const {  columns, type } = this
      const values = innerValue.map((value, index) => parseInt(columns[index][value], 10));
    
      if (type === 'time') {
        return values.join(':')
      }
      
      if (type !== 'year-month') {
        const year = values[0]
        const month = values[1]
        const day = getMonthEndDay(year, month)
        values[2] = parseInt(values[2], 10) > day ? day : values[2]
      }
      
      return new Date(
        [
          values.slice(0, 3).join('/'),
          values.slice(3).join(':')
        ].join(' ')
      ).getTime();
    },

    getOriginColumns() {
      const { type } = this
      if(type === 'time') {
        return [
          [this.minHour, this.maxHour], 
          [this.minMinute,this.maxMinute]
        ].map(([min, max]) => getRange(min, max))
      } 

      let range = this.getDateTime();

      if(type === 'date') range = range.slice(0, 3) 
      if(type === 'year-month') range = range.slice(0, 2)

      const formatter = this.formatter || defaultFormtter;
      return range.map(([min, max, type]) => {
        if (type === 'year') {
          return formatter(getRangeYear(min, max), type)
        }
        return formatter(getRange(min, max), type)
      })
    }
  },

  created() {
    
  },
})
</script>

<script name='json'>
  module.exports = { 
    "component": true,
    "usingComponents": {
      'es-picker': './index'
    }
  }
</script>

